import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, computed, forwardRef, signal } from '@angular/core';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DropdownOptionService } from '../dropdowns/dropdown-option.service';
import { ControlValueAccessor, FormBuilder, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subscription, asyncScheduler, pairwise, startWith } from 'rxjs';
import { InputMaskModule } from 'primeng/inputmask';
import { SelectModule } from 'primeng/select';

@Component({
    selector: 'app-birthday-picker',
    imports: [AutoCompleteModule, ReactiveFormsModule, SelectModule, InputMaskModule],
    templateUrl: './birthday-picker.component.html',
    styleUrl: './birthday-picker.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => BirthdayPickerComponent),
            multi: true
        }
    ]
})
export class BirthdayPickerComponent implements OnInit, ControlValueAccessor {


  minDate = new Date(1900, 0, 1)
  maxDate = new Date()
  birthdayValue: Date | null = null


  months = this.dropdownService.months("long")
  monthSuggestions = this.months
  days: number[] = this.dropdownService.daysForMonth(0)


  subscriptions: Subscription[] = []


  monthSelected = signal<boolean>(false)

  monthTouched = false
  dayTouched = false
  yearTouched = false


  dayEnabled = computed(() => {
    return !this.disabled() && this.monthSelected()
  })



  constructor(
    private dropdownService: DropdownOptionService,
    private chRef: ChangeDetectorRef,
    private fb: FormBuilder,
  ) {

  }
  ngOnInit(): void {
    this.updateDropdowns()
    this.subscriptions.push(this.form.valueChanges.pipe(startWith(null), pairwise()).subscribe(([prev, current]) => {

      if (current) {
        if (current?.month) {
          this.days = this.dropdownService.daysForMonth(current.month, current.year)
          this.chRef.markForCheck()
        }


        if (current.month !== prev?.month || current.day !== prev?.day || current.year !== prev?.year) {

          if (current.month != undefined && current.day != undefined && current.year ) {
            this.birthdayValue = new Date(current.year, current.month, current.day)
            this.onChange(this.birthdayValue)
          }
          else {
            this.onChange(null)
          }

        }


      }

    }))
  }

  form = this.fb.group({
    month: this.fb.control<number | null>(null),
    day: this.fb.control<number | null>(null),
    year: this.fb.control<number | "">("")
  })

  selectedDate: Date | null = null
  selectedMonth: number | null = null
  selectedDay: number | null = null
  year: number | "" = ""

  onChange: any = () => { };
  onTouched: any = () => { };
  disabled = signal<boolean>(false);
  touched = false;
  focused = false;


  writeValue(obj: Date | ""): void {



    if (obj === "" || obj < this.minDate) {
      this.birthdayValue = null
    }
    else {
      this.birthdayValue = obj
    }

    this.updateDropdowns()

  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }


  setDisabledState?(isDisabled: boolean): void {
    this.disabled.set(isDisabled)

    if (isDisabled) {
      this.form.disable()
    }
    else {
      this.form.enable()
    }
  }

  updateDropdowns() {

    if (this.birthdayValue) {
      this.form.setValue({
        month: this.birthdayValue.getMonth(),
        day: this.birthdayValue.getDate(),
        year: this.birthdayValue.getFullYear()
      })


    }
    else {
      this.form.setValue({
        month: null,
        day: null,
        year: null
      })

    }

    this.chRef.markForCheck()
  }


  controlTouched(event: any) {
    this.focused = false

    //wait to see if they clicked one of the other controls in this component before we trigger onTouched
    asyncScheduler.schedule(() => {
      if (!this.touched && !this.focused) {
        this.onTouched()
        this.touched = true
      }
    }, 250)

  }

  controlFocused(event: any) {
    this.focused = true
  }


}
